module.exports = __webpack_public_path__ + "media/images/logo/fhir-011e79a4bd4773a2858f12dbfdaf68ae.png";